import { Currency } from "src/app/external-remote/currency/currency";
import getSymbolFromCurrency from 'currency-symbol-map'

export class CurrencyUtils {

  public static getCurrencySymbol(currency: Currency): string {

    if (currency == null) {
      return null;
    }

    if (currency.symbol?.length > 0) {
      return currency.symbol;
    }

    let symbol = currency?.name;
    if (currency?.isoCode?.length > 0) {
      symbol = getSymbolFromCurrency(currency.isoCode);
      return symbol ? symbol : currency.isoCode;
    }
    return symbol;
  }

}
